import { render, staticRenderFns } from "./WarehouseCargoArea.vue?vue&type=template&id=6e03975e&scoped=true&"
import script from "./WarehouseCargoArea.vue?vue&type=script&lang=js&"
export * from "./WarehouseCargoArea.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseCargoArea.vue?vue&type=style&index=0&id=6e03975e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e03975e",
  null
  
)

export default component.exports